import { getInstanceId } from '@va/dashboard/selectors/app';
import { LocalStorage } from '@va/util/helpers';
import { isArray } from 'lodash';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

export const useStoreLineChartKpis = ({ id, allAvailableKPIs }: { id: string; allAvailableKPIs: string[] }) => {
  const websiteId = useSelector(getInstanceId);

  const getKPIsLocalstorageKey = useCallback(() => `${websiteId}-${id}`, [id, websiteId]);

  const getStoredKPIs: () => string[] | undefined = useCallback(() => {
    const storedItems = LocalStorage.getItem(getKPIsLocalstorageKey());
    if (!storedItems || storedItems === 'null') return undefined;
    try {
      const kpis = JSON.parse(storedItems);
      if (isArray(kpis)) {
        return kpis;
      }
      return undefined;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }, [getKPIsLocalstorageKey]);

  const [visibleKPIs, setVisibleKPIs] = useState(getStoredKPIs() ?? allAvailableKPIs);

  const onKPIClick = useCallback(
    (kpi: string) => {
      setVisibleKPIs((prev) => {
        const newItems = prev.includes(kpi) ? prev.filter((element) => element !== kpi) : [...prev, kpi];
        LocalStorage.setItem(getKPIsLocalstorageKey(), JSON.stringify(newItems));
        return newItems;
      });
    },
    [getKPIsLocalstorageKey],
  );

  return { visibleKPIs, onKPIClick };
};
